
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/CheckOrganization/CheckOrganization.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./CheckOrganization.html');
        
        var script = require('./CheckOrganization.ts').default;
        module.exports = require('./CheckOrganization.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    